export default function deleteMigrationTrackingReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DELETE_MIGRATION_TRACKING_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_MIGRATION_TRACKING_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_MIGRATION_TRACKING_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}